module.exports = __webpack_public_path__ + "img/login.7e193fb3.png";